if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        super.connectedCallback?.();
        if (this.dataset.modalCarouselDelegate) return;
        this.dataset.modalCarouselDelegate = 'true';
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-modal-carousel-prev]')) {
            e.preventDefault();
            this.scrollModalCarousel(-1);
          } else if (e.target.closest('[data-modal-carousel-next]')) {
            e.preventDefault();
            this.scrollModalCarousel(1);
          }
        });
      }

      scrollModalCarousel(direction) {
        const track = this.querySelector('.product-media-modal__track');
        if (!track) return;
        const slideW = track.clientWidth;
        const idx = Math.round(track.scrollLeft / slideW);
        const slides = track.querySelectorAll('.product-media-modal__slide');
        const maxIdx = Math.max(0, slides.length - 1);
        const nextIdx = Math.max(0, Math.min(maxIdx, idx + direction));
        track.scrollTo({ left: nextIdx * slideW, behavior: 'smooth' });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        const slides = this.querySelectorAll('.product-media-modal__slide');
        const track = this.querySelector('.product-media-modal__track');
        let activeSlide = null;

        slides.forEach((slide) => {
          const match = slide.getAttribute('data-media-id') === mediaId;
          slide.classList.toggle('active', match);
          if (match) activeSlide = slide;
        });

        if (track && activeSlide) {
          requestAnimationFrame(() => {
            track.scrollTo({ left: activeSlide.offsetLeft, behavior: 'auto' });
          });
        }

        const activeDeferred = activeSlide?.querySelector('deferred-media');
        const activeTemplate = activeSlide?.querySelector('template');
        const activeMediaContent = activeTemplate ? activeTemplate.content : null;

        if (
          activeDeferred?.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeDeferred.loadContent();
        }

        activeSlide?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
      }
    }
  );
}
